// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lt-tour-scaffold {
  min-height: 100svh;
  min-height: 100dvh;
  padding: 24px 16px 48px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  box-sizing: border-box;
}

.lt-tour-scaffold .lt-pv__wait-card {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.lt-tour-scaffold .lt-hero {
  min-height: 120px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 8px;
}

.lt-tour-scaffold__kicker {
  margin: 0;
  font-size: 12px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  opacity: 0.72;
}

.lt-tour-scaffold .lt-pv__table-panel {
  width: 100%;
}

.lt-tour-scaffold .lt-coach-dash {
  min-height: 220px;
}

.lt-tour-scaffold .lt-coach-bar-wrap {
  margin-top: auto;
}
`, "",{"version":3,"sources":["webpack://./src/pages/LiveTraining/LiveTrainingTourScaffold.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".lt-tour-scaffold {\n  min-height: 100svh;\n  min-height: 100dvh;\n  padding: 24px 16px 48px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  box-sizing: border-box;\n}\n\n.lt-tour-scaffold .lt-pv__wait-card {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.lt-tour-scaffold .lt-hero {\n  min-height: 120px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 8px;\n}\n\n.lt-tour-scaffold__kicker {\n  margin: 0;\n  font-size: 12px;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  opacity: 0.72;\n}\n\n.lt-tour-scaffold .lt-pv__table-panel {\n  width: 100%;\n}\n\n.lt-tour-scaffold .lt-coach-dash {\n  min-height: 220px;\n}\n\n.lt-tour-scaffold .lt-coach-bar-wrap {\n  margin-top: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
